let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3y58W")).then(() => parcelRequire('5uPg2'));